import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const disableColor = css`
  &:disabled {
    color: ${theme.colors.SurfaceRaisinBlack50};
  }
`;

export const CustomTextarea = styled.textarea`
  color: ${theme.colors.SurfaceRaisinBlack50};
  outline: 0 transparent;
  border: 0 transparent;
  padding: 8px 16px;
  resize: vertical;

  &:focus {
    outline: 0 transparent;
    border: 0 transparent;
  }

  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  border-radius: 8px;
`;

export const CustomField = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  border-radius: 8px;
  background-color: ${theme.colors.SurfaceWhite};
  padding: 8px 16px;

  height: 36px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;

    /* make each column take full width */
    & > * {
      width: 100% !important;
    }
  }
`;
